import React from 'react';
import ForntPageFontComponent from '../components/forntPageFontComponent';

const ForntPageFont = () => {
  return <ForntPageFontComponent />;
};

export default ForntPageFont;
